import { Section } from "modules/layout";
import { ProfileAvatarForm, ProfileNameForm } from "modules/profile";
import ProfileLayout from "./_layout";

const ProfileSettings = () => {
  return (
    <ProfileLayout>
      <Section>
        <ProfileAvatarForm />
      </Section>
      <Section>
        <ProfileNameForm />
      </Section>
    </ProfileLayout>
  );
};

export default ProfileSettings;
